import {Pagamento} from "../objeto/Pagamento";
import {DadosCartao} from "../objeto/DadosCartao";
import {FormasPagamentoLoja} from "./formas-pagamentos/formas-pagamento-loja";

export abstract class  PagamentoLojaBase{
  statusStrongAuthCartao: any = null;
  cartoesSalvosPagarme: any[] = [];
  carregandoCartoes = false;
  msgErro: string
  empresa: any = {};
  constructor() { }

  abstract obtenhaPagamento(): Pagamento;
  abstract obtenhaCrlPagamento(): FormasPagamentoLoja;

  abstract fazerPedido();

  apliqueCartaoSalvoPadrao(){
    if(!this.cartoesSalvosPagarme || !this.cartoesSalvosPagarme.length)
      return;
    if(!this.statusStrongAuthCartao ||
      !this.statusStrongAuthCartao.aceitouCartaoSalvo ||
      !this.statusStrongAuthCartao.possuiCartaoSalvo)
      return;

    let pagamento: any = this.obtenhaPagamento()

    const dadosCartao: any = pagamento.dadosCartao || new DadosCartao();
    if(dadosCartao.token && dadosCartao.cartaoSalvoId)
      return;

    let cartaoSelecionado = this.cartoesSalvosPagarme[0];
    if(dadosCartao.cartaoSalvoId){
      cartaoSelecionado = this.cartoesSalvosPagarme.find((item: any) => item.id === dadosCartao.cartaoSalvoId) || cartaoSelecionado;
    }

    dadosCartao.cartaoSalvoId = cartaoSelecionado.id;
    dadosCartao.bandeira = cartaoSelecionado.bandeira;
    dadosCartao.ultimosNumeros = cartaoSelecionado.ultimosNumeros;
    dadosCartao.descricaoPagamento = cartaoSelecionado.descricaoPagamento;

    pagamento.dadosCartao = dadosCartao;

    this.apliqueFormaPagamentoCartaoSalvoPadrao();
  }


  apliqueFormaPagamentoCartaoSalvoPadrao(){
    let pagamento: any = this.obtenhaPagamento()

    if(this.ehFormaPagarmeOnline( pagamento?.formaDePagamento))
      return;

    const formaPadrao = this.obtenhaFormaPagarmeOnlinePadrao();
    if(!formaPadrao)    return;


    pagamento.formaDePagamento = formaPadrao;

    const ctrlPagamento: any = this.obtenhaCrlPagamento();
    if(ctrlPagamento)
      ctrlPagamento.escolheuFormaDePagamentoOnline(formaPadrao);
  }

  obtenhaFormaPagarmeOnlinePadrao(){
    const formas = this.empresa?.formasDePagamento || [];
    return formas.find((forma: any) =>
      forma && forma.exibirCardapio && this.ehFormaPagarmeOnline(forma)
    ) || null;
  }

  deveBloquearPagamentoPorStrongAuth(){
    let pagamento: any = this.obtenhaPagamento()

    if(!this.ehFormaPagarmeOnline(pagamento?.formaDePagamento))
      return false;
    if(!this.statusStrongAuthCartao)
      return false;

    //nao e um cartao salvo, foi digitado
    if(!pagamento.dadosCartao?.cartaoSalvoId) return false;

    return this.statusStrongAuthCartao.aceitouCartaoSalvo === true &&
      this.statusStrongAuthCartao.autenticacaoForteValida !== true;
  }


  ehFormaPagarmeOnline(forma: any){
    if(!forma || !forma.online || forma.pix || !forma.configMeioDePagamento)
      return false;

    const meio = forma.configMeioDePagamento.meioDePagamento;
    return meio === 'pagarme' || meio === 'pagarmehub';
  }

  onCartoesSalvosCarregados(cartoes: any[]) {
    let pagamento: any = this.obtenhaPagamento()

    this.cartoesSalvosPagarme = cartoes;
    if(!pagamento.dadosCartao)
      pagamento.dadosCartao = new DadosCartao();

    this.apliqueCartaoSalvoPadrao();
  }

  onStatusStrongAuthAlterado(status: any) {
    this.statusStrongAuthCartao = status;
  }

  verificarCartoesUsuario(){
    return this.obtenhaCrlPagamento()?.vetificarCartoesUsuario;
  }

  onAutenticacaoCancelada(){
    this.msgErro = 'Para continuar, é necessário realizar a autenticação enviada ao seu e-mail.'
  }

  onVerificandoCartoes(estaVerificando: boolean) {
    setTimeout(() => {
      this.carregandoCartoes = estaVerificando;
    }, 0);
  }

  onAutenticacaoSucesso() {
    if (this.statusStrongAuthCartao) {
      this.statusStrongAuthCartao.autenticacaoForteValida = true;
    }
    setTimeout(() => {
      this.fazerPedido();
    }, 100);
  }
}
